import http from '../plugins/axios'

export const getChatList = async (params) => {
  try {
    const response = await http.get(`/api/v2/chat`, { params })
    return response
  } catch(error) {
    throw error
  }
}

export const getChatDetail = async (id, params) => {
  try {
    const response = await http.get(`/api/v2/chat/${id}`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const joinChat = async (payload) => {
  try {
    const response = await http.post('/api/v2/chat/join', payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getMessageList = async (id, params) => {
  try {
    const response = await http.get(`/api/v2/chat_message/${id}`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const sendMessage = async (payload) => {
  try {
    const response = await http.post('/api/v2/chat_message/', payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const sendMessageImage = async (chatId, payload) => {
  try {
    const response = await http.post(`/api/v2/chat/${chatId}/images`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const sendMessageDocument = async (chatId, payload) => {
  try {
    const response = await http.post(`/api/v2/chat/${chatId}/documents`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const closeChat = async (id) => {
  const payload = { chat_id: id, status: 'closed' }
  try {
    const response = await http.post('/api/v2/chat/status', payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteChat = async (chat_id) => {
  try {
    const response = await http.delete(`/api/v2/chat/${chat_id}`)
    return response.data
  } catch(error) {
    throw error
  }
}

